import PlanList from "../views/PlansList.vue"
import PlanDetail from "../views/PlanDetail.vue"

export default [
	{
		path: "/:tenantId/plans",
		component: PlanList,
		name: "PlansList",
		meta: { featureId: "plans" },
		props: true
	},
	{
		path: "/:tenantId/plans/detail/:plan/:type/:version?",
		component: PlanDetail,
		name: "PlanDetail",
		meta: { featureId: "plans" },
		props: true
	}
]
